// @module Convergence.GlobalExt.GlobalExt
define('Convergence.GlobalExt.GlobalExt.View'
,	[
	'convergence_globalext_globalext.tpl'
	,	'Backbone'
    ]
, function (
	convergence_globalext_globalext_tpl
	,	Backbone
)
{
    'use strict';

	// @class Convergence.GlobalExt.GlobalExt.View @extends Backbone.View
	return Backbone.View.extend({

		template: convergence_globalext_globalext_tpl

	,	initialize: function (options) {

			/*  Uncomment to test backend communication with an example service
				(you'll need to deploy and activate the extension first)
			*/

			// this.model = new GlobalExtModel();
			// var self = this;
         	// this.model.fetch().done(function(result) {
			// 	self.message = result.message;
			// 	self.render();
      		// });
		}

	,	events: {
		}

	,	bindings: {
		}

	, 	childViews: {

		}

		//@method getContext @return Convergence.GlobalExt.GlobalExt.View.Context
	,	getContext: function getContext()
		{
			//@class Convergence.GlobalExt.GlobalExt.View.Context
			this.message = this.message || 'Hello World!!'
			return {
				message: this.message
			};
		}
	});
});
